"use client"
import { LinkType } from '@/libs/types'
import React from 'react'

interface PricingCTblFeatureProps {
    features: Array<LinkType>
}
const PricingCTblFeatures: React.FC<PricingCTblFeatureProps> = ({
    features = []
}) => {
    const OFFSET_HEIGHT_PX = 81; // height of navbar ~ 81.09

    const handlerScrollMooth = (feature: LinkType) => {
        const element = document.getElementById(feature.href.replace("#", "")) as any
        if (!element) return
        const OFFSET_TOP = element.getBoundingClientRect().top + window.pageYOffset - OFFSET_HEIGHT_PX
        if (feature.featured) {
            let navLinks = element.getElementsByClassName("nav-link")
            let tabContent = element.getElementsByClassName("tab-content")[0]
            let tabPanels = tabContent.querySelectorAll("[role='tabpanel']");
            Array.prototype.map.call(
                navLinks,
                (navLink, index: number) => {
                    navLink.classList.remove("active")
                    tabPanels[index].classList.remove("active")
                    tabPanels[index].classList.remove("show")

                    if ((index === 0 && feature.text === "CDN Comparison") ||
                        (feature?.text === "Origin Shield" && index === 3) ||
                        (feature.text === "Stream" && index === 4)) {
                        tabPanels[index].classList.add("active")
                        tabPanels[index].classList.add("show")
                        return navLink.classList.add("active")
                    }
                    return navLink
                }
            )
        }
        window.scrollTo({ top: OFFSET_TOP, behavior: "smooth" });
    }
    return (
        <div className="d-flex features justify-content-center mt-4 mb-3 mb-md-5">
            {features && features.map((feature: LinkType, index: number) => {
                return (
                    <a key={index} className="feature-scroll"
                        onClick={() => handlerScrollMooth(feature)}>
                        <div className={`feature-images`}>
                            <span className={`feature-image ${feature?.icon}`} />
                        </div>
                        <span>
                            {feature?.text}
                        </span>
                    </a>
                )
            })}
        </div>
    )
}

export default PricingCTblFeatures